/**
 * Employee Incident Export Management Service
 * HTTP operations for the hybrid (sync/async) export of the admin-wide incident listing (ASIS-5245)
 */
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';
import type { LC_ExportIncidentsManagementIn, IncidentManagementExportHybridResult } from '../types';

/**
 * Service for exporting the admin-wide (all employees) incident listing to Excel
 */
export class EmployeeIncidentExportManagementService {
  /**
   * Export incidents for management with filters, using the hybrid sync/async strategy
   * GET /v{version}/attendances/incidents/file
   */
  async exportManagement(
    params: LC_ExportIncidentsManagementIn,
  ): Promise<ApiResponse<IncidentManagementExportHybridResult>> {
    const queryString = buildQueryString({ ...params });
    const endpoint = `${API_CONFIG.ENDPOINTS.EMPLOYEE_INCIDENTS.FILE_MANAGEMENT()}${queryString}`;

    return apiClient.downloadBlobOrAcceptJob(endpoint, { method: 'GET' });
  }
}

export const employeeIncidentExportManagementService =
  new EmployeeIncidentExportManagementService();
